import React, { useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import {
  Board, BoardItem, BoardContainer, BoardItemPlaceholder,
} from './styles';

import { Splitview, Split } from '../../Split';

type BoardPickerProps = {
  title: String,
  subTitle: String,
  boards: Array,
  answer: Array,
  setAnswer: Function,
  max: Number,
  setTip: Function,
};

const BoardPicker = ({
  title,
  subTitle,
  boards: initialItems,
  answer = [],
  setAnswer,
  max = null,
  setTip,
}: BoardPickerProps) => {
  const [items, setItems] = useState(initialItems.filter(item => answer.indexOf(item) === -1));
  const placeholders = new Array(max - answer.length).fill(null);

  const handleDragEnd = ({ draggableId, destination, source }) => {
    if (!destination) return null;

    const { droppableId, index: destinationIndex } = destination;
    const { index: sourceIndex } = source;

    if (droppableId === 'chosenItems') {
      setItems([...items.slice(0, sourceIndex), ...items.slice(sourceIndex + 1)]);
      const newValue = [
        ...answer.slice(0, destinationIndex),
        draggableId,
        ...answer.slice(destinationIndex),
      ];
      setAnswer(newValue);
      setTip(newValue);
    }
  };
  return (
    <Splitview>
      <Split width={100}>
        <h2 className="question-heading">{title}</h2>
        <div className="question-description">
          <p>{subTitle}</p>
        </div>
        <BoardContainer>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable isDropDisabled droppableId="items">
              {(provided, snapshot) => (
                <Board {...provided.droppableProps} ref={provided.innerRef}>
                  {items.map((board, index) => (
                    <Draggable key={board} draggableId={board} index={index}>
                      {(provided, snapshot) => (
                        <BoardItem
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <span>{board}</span>
                        </BoardItem>
                      )}
                    </Draggable>
                  ))}
                </Board>
              )}
            </Droppable>
            <Droppable droppableId="chosenItems">
              {(provided, snapshot) => (
                <Board {...provided.droppableProps} ref={provided.innerRef}>
                  {answer.map((board, index) => (
                    <Draggable isDragDisabled key={index} draggableId={index + 1} index={index}>
                      {(provided, snapshot) => (
                        <BoardItem
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className="selected"
                        >
                          <span>{board}</span>
                        </BoardItem>
                      )}
                    </Draggable>
                  ))}
                  {placeholders.map((board, index) => (
                    <Draggable isDragDisabled key={index} draggableId={index + 1} index={index}>
                      {(provided, snapshot) => (
                        <BoardItemPlaceholder
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        />
                      )}
                    </Draggable>
                  ))}
                </Board>
              )}
            </Droppable>
          </DragDropContext>
        </BoardContainer>
      </Split>
    </Splitview>
  );
};
export default BoardPicker;
